const status = {
	running: "Actief",
	stopped: "Gestopt",
	unknown: "Onbekend",
};

export default status;
